export default __webpack_public_path__ + "static/media/tungchef.789bdf40.png";